import { render, staticRenderFns } from "./CduWrapper.vue?vue&type=template&id=7dbfba94&scoped=true&"
import script from "./CduWrapper.vue?vue&type=script&lang=js&"
export * from "./CduWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CduWrapper.vue?vue&type=style&index=0&id=7dbfba94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbfba94",
  null
  
)

export default component.exports